import { useEffect, useState } from 'react';
import { Heading } from '@lmig/lmds-react-typography';
import { Button } from '@lmig/lmds-react-button';
import { Form } from '@lmig/lmds-react-form';
import { FieldGroup } from '@lmig/lmds-react-field-group';
import globalConfig from '../../Data/globalConfig.json';
import './CustomerSearch.scss';
import { SearchInput } from '@lmig/lmds-react-alphanumeric-input';
import { useLocation, useNavigate } from 'react-router-dom';

interface ICustomerSearchProps {
  close: Function;
  showHorizontalMenu: boolean;
}

const CustomerSearch = (props: ICustomerSearchProps) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [formError, setFormError] = useState<boolean>(false);
  let navigate = useNavigate();
  const { search } = useLocation();
  const errorMessage = 'Please enter at least one character before searching.';

  useEffect(() => {
    if (search) setSearchTerm(new URLSearchParams(search).get('searchTerm') ?? '');
  }, [search]);

  const searchCustomers = () => {
    if (isFormValid()) {
      /*use below value to trigger location change hook in react 
        when the user clicks search without changing the search term so that we can still focus search results tab*/
      let triggerLocationChange =
        new URLSearchParams(search).get('searchTerm') == searchTerm ? `&searchId=${Math.random()}` : '';
      navigate(`${globalConfig.CustomerSearch.path}?searchTerm=${searchTerm}${triggerLocationChange}`);
      if (props.showHorizontalMenu) props.close();
    }
  };

  const isFormValid = () => {
    let valid = true;
    if (searchTerm.length < 1) {
      valid = false;
    }
    setFormError(!valid);
    return valid;
  };

  return (
    <div className="customer-search">
      <Heading type="h4">Customer lookup</Heading>
      <p>Look up a customer by name, policy number, email, claim or phone.</p>
      <Form onSubmit={() => searchCustomers()}>
        <FieldGroup
          messages={formError && errorMessage?.length > 0 ? [{ text: errorMessage, type: 'error' }] : []}
        ></FieldGroup>
        <div data-theme="evolved">
          <SearchInput
            labelVisual="Search customer"
            value={searchTerm}
            onChange={(event) => {
              setSearchTerm(event.target.value.trim());
              setFormError(false);
            }}
            color={!formError ? 'primary' : 'secondary'}
            onClearClicked={() => setSearchTerm('')}
          />
          <Button className="customer-search-button" dynamicWidth variant="primary" type="submit">
            Search
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default CustomerSearch;
